/**
 * Geliştirme konsol logları — varsayılan kapalı.
 * Açmak için: VUE_APP_DEBUG_LOGS=true
 */
const debugEnabled = process.env.VUE_APP_DEBUG_LOGS === "true";
export const logger = {
    debug: (...args) => {
        if (debugEnabled)
            console.log(...args);
    },
    warn: (...args) => {
        if (debugEnabled)
            console.warn(...args);
    },
    error: (...args) => {
        console.error(...args);
    },
};
